module.exports = __webpack_public_path__ + "static/media/benchmark-bkg-0.d6e5a895.svg";